import React, { useRef, useState, useContext } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Assets from "../../Assets/Assets";
import "./SideBar.css";
import AppContext from "../../Context/AppContext";

const SideBar = () => {
  const [isOpen, setIsOpen] = useState(true);
  const { user, setUser } = useContext(AppContext);
  console.log("usr name", user);
  const navigate = useNavigate();

  const toggle = () => setIsOpen(!isOpen);

  const menuItem = [
    {
      path: "/",
      name: "Home",
      icon: <img className="non-active-icon" src={Assets.home} alt="Home" />,
      activeIcon: (
        <img
          className="active-icon"
          src={Assets.active_home}
          alt="My Applications"
        />
      ),
    },
    {
      path: "/appointments",
      name: "Appointments",
      icon: (
        <img
          className="non-active-icon"
          src={Assets.appointment}
          alt="My Applications"
        />
      ),
      activeIcon: (
        <img
          className="active-icon"
          src={Assets.active_appointment}
          alt="My Applications"
        />
      ),
    },
    {
      path: "/slotsetup",
      name: "Slot Setup",
      icon: (
        <img
          className="non-active-icon"
          src={Assets.clock}
          alt="My Applications"
        />
      ),
      activeIcon: (
        <img
          className="active-icon"
          src={Assets.active_clock}
          alt="My Applications"
        />
      ),
    },
    {
      path: "/patients",
      name: "Patients",
      icon: (
        <img
          className="non-active-icon"
          src={Assets.patient}
          alt="My Applications"
        />
      ),
      activeIcon: (
        <img
          className="active-icon"
          src={Assets.active_patient}
          alt="My Applications"
        />
      ),
    },
    {
      path: "/analytics",
      name: "Statistics",
      icon: (
        <img
          className="non-active-icon"
          src={Assets.analytics}
          alt="My Applications"
        />
      ),
      activeIcon: (
        <img
          className="active-icon"
          src={Assets.active_analytics}
          alt="My Applications"
        />
      ),
    },
    {
      path: "/profile",
      name: "Profile",
      icon: (
        <img
          className="non-active-icon"
          src={Assets.profile}
          alt="My Applications"
        />
      ),
      activeIcon: (
        <img
          className="active-icon"
          src={Assets.active_profile}
          alt="My Applications"
        />
      ),
    },
    {
      path: "mailto:info@digidoc.co.in",
      name: "Contact Us",
      icon: (
        <img
          className="non-active-icon"
          src={Assets.contact}
          alt="My Applications"
        />
      ),
      activeIcon: (
        <img
          className="active-icon"
          src={Assets.active_contact}
          alt="My Applications"
        />
      ),
    },
  ];

  const handleLogout = () => {
    setUser({ type: "logout" });
    localStorage.removeItem("loggedIn");
    localStorage.removeItem("token");
    localStorage.clear();
    navigate("/");
  };

  return (
    <div className="layout-sec">
      <div className="header-sec">
        <img
          src={Assets.digi_logo}
          alt="Digi Logo"
          style={{ margin: "10px", cursor: "pointer"}}
          onClick={() => navigate("/")}
        />
      </div>
      {/* <div className="serach-sec">
        <input type="search" placeholder="Search" className="search-input" />
        <img src={Assets.search_icon} alt="Search" className="search-icon " />
      </div> */}
      {/* sidebar */}
      <div className="sidebar">
        <div className="sidebar_content h-100">
          {menuItem.map((item, index) => (
            <NavLink
              to={item.path}
              key={index}
              className="links mr-2"
              activeclassName="active"
            >
              {item.icon}
              {item.activeIcon}
              <div
                style={isOpen ? { display: "block" } : { display: "none" }}
                className="link_text"
              >
                {item.name}
              </div>
            </NavLink>
          ))}
          <div className="footer-sec" onClick={() => handleLogout()}>
            <img src={Assets.logout_icon} alt="Logout Logo" />
            <p className="log-txt">Logout</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
